<template>
  <div class="container">
    <md-sidenav class="main-sidebar md-left md-fixed" ref="main-sidebar"  v-if="auth.user.authenticated">

      <md-toolbar class="vue-material-logo" md-theme="white" style="border-bottom-style: none;">
        <router-link exact to="/landing">
          <img :src="logo" alt="Vue" style="border-radius:20px; width:130px; margin-top:10px;">
          <span></span>
        </router-link>
      </md-toolbar>

      <md-list>
        <div v-if="auth.user.hasRole_keuangan === true">

          <md-list-item class="pd_center" md-align="center">
            <div class="has-ripple purple" align="center">
              <md-ink-ripple />
              <span> MENU - KEUANGAN </span>
            </div>
          </md-list-item>

          <md-list-item>
            <span><md-icon class="md-primary">import_contacts</md-icon> &nbsp; Reports</span>
            <md-list-expand>
              <md-list>
                <md-list-item class="md-inset">
                  <router-link exact to="/reports/dailyheaders">Daily Headers</router-link>
                </md-list-item>
                <md-list-item class="md-inset">
                  <router-link exact to="/reports/dailydetails">Daily Details</router-link>
                </md-list-item>
                <md-list-item class="md-inset">
                  <router-link exact to="/reports/finefeedetails">Fine Fee Details</router-link>
                </md-list-item>
                <md-list-item class="md-inset">
                  <router-link exact to="/reports/parkfeedetails">Park Fee Details</router-link>
                </md-list-item>
                <md-list-item class="md-inset">
                  <router-link exact to="/reports/itemdetails">Items Reported</router-link>
                </md-list-item>
                <md-list-item class="md-inset">
                  <router-link exact to="/reports/defectdetails">Defects Reported</router-link>
                </md-list-item>
              </md-list>
            </md-list-expand>
          </md-list-item>

        </div>


        <div v-else-if="auth.user.hasRole_adminsystem === true">

          <md-list-item class="pd_center" md-align="center">
            <div class="has-ripple purple" align="center">
              <md-ink-ripple />
              <span> MENU - ADMIN SYSTEM </span>
            </div>
          </md-list-item>

          <md-list-item>
            <span> <md-icon class="md-warn">local_library</md-icon> &nbsp; MASTERS </span>
            <md-list-expand>
              <md-list>
                <div style="padding-left:20px;">
                  <md-list-item @click.native="redirect('adsys:masters:company', 'MASTER - COMPANIES')">
                    <span><md-icon class="md-primary">domain</md-icon> &nbsp; Companies</span>
                  </md-list-item>
                  <md-list-item @click.native="redirect('adsys:masters:car', 'MASTER - CARS')">
                    <span><md-icon class="md-primary">local_taxi</md-icon> &nbsp; Cars</span>
                  </md-list-item>
                  <md-list-item @click.native="redirect('adsys:masters:color', 'MASTER - COLORS')">
                    <span><md-icon class="md-primary">invert_colors</md-icon> &nbsp; Colors</span>
                  </md-list-item>
                  <md-list-item @click.native="redirect('adsys:masters:monitor', 'MASTER - MONITORS')">
                    <span><md-icon class="md-primary">timeline</md-icon> &nbsp; Monitor</span>
                  </md-list-item>
                  <md-list-item @click.native="redirect('adsys:masters:status', 'MASTER - STATUS')">
                    <span><md-icon class="md-primary">notifications_paused</md-icon> &nbsp; Status</span>
                  </md-list-item>
                  <md-list-item @click.native="redirect('adsys:masters:role', 'MASTER - ROLE')">
                    <span><md-icon class="md-primary">group</md-icon> &nbsp; Role</span>
                  </md-list-item>
                  <md-list-item @click.native="redirect('adsys:masters:postal', 'MASTER - POSTAL CODE')">
                    <span><md-icon class="md-primary">local_post_office</md-icon> &nbsp; Postal Code</span>
                  </md-list-item>
                  <md-list-item @click.native="redirect('adsys:masters:payment_categories', 'MASTER - PAY Category')">
                    <span><md-icon class="md-primary">monetization_on</md-icon> &nbsp; Payment Categories</span>
                  </md-list-item>
                  <md-list-item @click.native="redirect('adsys:masters:defect_master', 'MASTER - Defects')">
                    <span><md-icon class="md-primary">healing</md-icon> &nbsp; Defects</span>
                  </md-list-item>
                  <md-list-item @click.native="redirect('adsys:masters:menu', 'MASTER - MENUS')">
                    <span><md-icon class="md-primary">menu</md-icon> &nbsp; MENU</span>
                  </md-list-item>
                </div>
              </md-list>
            </md-list-expand>
          </md-list-item>

        </div>

        <div v-else-if="auth.user.hasRole_administrative === true">

          <md-list-item class="pd_center" md-align="center">
            <div class="has-ripple purple" align="center">
            <md-ink-ripple />
            <span> MENU - RUNNER / CASHIER </span>
            </div>
          </md-list-item>

          <md-list-item>
            <md-icon class="md-primary">directions_car</md-icon>
            <span> Status </span>
            <md-list-expand>
              <md-list>
                <md-list-item @click.native="redirect('administrative:status_checkin', 'Status Check In')" class="md-inset">
                  <span> Check In </span>
                </md-list-item>
                <md-list-item @click.native="redirect('administrative:status_checkout', 'Status Check Out')" class="md-inset">
                  <span> Check Out </span>
                </md-list-item>
                <md-list-item @click.native="redirect('administrative:status_all', 'Status All')" class="md-inset">
                  <span> All Status </span>
                </md-list-item>
                <md-list-item @click.native="redirect('administrative:history', 'Histories')" class="md-inset">
                  <span> Log Histories </span>
                </md-list-item>
              </md-list>
            </md-list-expand>
          </md-list-item>

          <md-list-item>
            <md-icon class="md-primary">trending_up</md-icon>
            <span> Reports </span>
            <md-list-expand>
              <md-list>
                <md-list-item @click.native="redirect('administrative:status_find', 'Find Data')" class="md-inset">
                  <span> Find Data </span>
                </md-list-item>
                <md-list-item @click.native="redirect('administrative:reports_main', 'Main Reports')" class="md-inset">
                  <span> Main Reports </span>
                </md-list-item>
              </md-list>
            </md-list-expand>
          </md-list-item>

        </div>

        <div v-else-if="auth.user.profile.role.rlms_id === 40">

          <md-list-item @click.native="redirect('keyguard:request', 'Requests')">
            <md-icon class="md-primary">notifications</md-icon>
            <span> Requests </span>
          </md-list-item>

          <md-list-item @click.native="redirect('keyguard:status', 'Status')">
            <md-icon class="md-primary">vpn_key</md-icon>
            <span> Status </span>
          </md-list-item>

          <md-list-item @click.native="redirect('keyguard:history', 'Histories')" >
            <md-icon class="md-primary">history</md-icon>
            <span> Histories </span>
          </md-list-item>

          <md-list-item>
            <md-icon class="md-primary">trending_up</md-icon>
            <span> Reports </span>
            <md-list-expand>
              <md-list>
                <md-list-item @click.native="redirect('keyguard:reports', 'Reports')" class="md-inset">
                  <span> Main Reports </span>
                </md-list-item>
                <md-list-item @click.native="redirect('keyguard:reports', 'Reports')" class="md-inset">
                  <span> Unclosed Reports </span>
                </md-list-item>
              </md-list>
            </md-list-expand>
          </md-list-item>
        </div>

        <div>
          <md-list-item class="pd_center" md-align="center">
            <div class="has-ripple purple" align="center">
            <md-ink-ripple />
            <span> USER PREFERENCE </span>
            </div>
          </md-list-item>

          <md-list-item @click.native="redirect('maps', 'Maps')" >
            <md-icon class="md-primary">my_location</md-icon>
            <span> Maps </span>
          </md-list-item>

          <md-list-item>
            <md-icon class="md-warn">account_circle</md-icon>
            <span> Account </span>
            <md-list-expand>
              <md-list>
                <md-list-item @click.native="redirect('preference:site', 'Change Site')" class="md-inset">
                  <span> Change Site </span>
                </md-list-item>
                <md-list-item @click.native="redirect('preference:profile', 'Change Profile')" class="md-inset">
                  <span> Change Profile </span>
                </md-list-item>
                <md-list-item @click.native="redirect('preference:password', 'Change Password')" class="md-inset">
                  <span> Change Password </span>
                </md-list-item>
                <md-list-item class="md-inset" @click.native="signout()">
                  Logout
                </md-list-item>
              </md-list>
            </md-list-expand>
          </md-list-item>

        </div>

      </md-list>
    </md-sidenav>

    <md-sidenav class="main-sidebar md-left md-fixed" ref="main-sidebar"  v-else-if="!auth.user.authenticated">
      <md-toolbar class="vue-material-logo" md-theme="white" style="border:0px;top: 50%;position: relative; transform: translateY(-50%);">
        <router-link exact to="/">
          <md-card-media md-with-hover>
            <md-ink-ripple />
              <img :src="logo" alt="Vue" style="border-radius:40px;" class="md-raised">
          </md-card-media>
        </router-link>
      </md-toolbar>
    </md-sidenav>

    <div v-if="auth.user.authenticated">
      <md-whiteframe md-tag="md-toolbar" md-elevation="1" class="main-header" >
        <md-button class="md-icon-button nav-trigger" @click.native="toggleSidenav">
          <md-icon>menu</md-icon>
        </md-button>
        <div class="md-title"> &nbsp; &nbsp; {{ pageTitle }}</div>
        <md-button rel="noopener" class="md-icon-button" @click.native="signout()">
          <md-icon>exit_to_app</md-icon>
        </md-button>
      </md-whiteframe>
    </div>

    <transition name="md-router" appear>
      <router-view></router-view>
    </transition>

  </div>
</template>


<style lang="scss">
  @import '~vue-material/src/core/stylesheets/variables.scss';

  $sizebar-size: 280px;

  [v-cloak] {
    display: none;
  }

  html,
  body {
    height: 100%;
    overflow: hidden;
  }

  body {
    display: flex;
  }

  .container {
    min-height: 100%;
    display: flex;
    flex-flow: column nowrap;
    flex: 1;
    transition: $swift-ease-out;
    overflow: auto;

    @media (min-width: 1281px) {
      padding-left: $sizebar-size;
    }
  }

  .main-sidebar.md-sidenav {
    .md-sidenav-content {
      width: $sizebar-size;
      display: flex;
      flex-flow: column;

      @media (min-width: 1281px) {
        top: 0;
        pointer-events: auto;
        transform: translate3d(0, 0, 0);
        box-shadow: $material-shadow-2dp;
      }
    }

    .md-backdrop {
      @media (min-width: 1281px) {
        opacity: 0;
        pointer-events: none;
      }
    }

    .md-toolbar {
      min-height: 172px;
      border-bottom: 1px solid rgba(#000, .12);
    }

    .vue-material-logo {
      font-size: 24px;

      a {
        width: 100%;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        color: inherit;
        text-decoration: none;

        &:hover {
          color: inherit;
          text-decoration: none;
        }
      }

      img {
        width: 160px;
        margin-bottom: 16px;
      }
    }

    .main-sidebar-links {
      overflow: auto;

      .md-inset .md-list-item-container {
        padding-left: 36px;
      }

      .md-list-item-container {
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  .main-content {
    padding: 16px;
    flex: 1;
    overflow: auto;
    background-color: #fff;
    transform: translate3D(0, 0, 0);
    transition: $swift-ease-out;
    transition-delay: .2s;
  }

  .md-router-enter,
  .md-router-leave {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;

    @media (min-width: 1281px) {
      left: $sizebar-size;
    }

    .main-content {
      opacity: 0;
      overflow: hidden;
    }
  }

  .md-router-leave {
    z-index: 1;
    transition: $swift-ease-in;
    transition-duration: .25s;
  }

  .md-router-enter {
    z-index: 2;
    transition: $swift-ease-out;

    .main-content {
      transform: translate3D(0, 10%, 0);
    }
  }

  code {
    &:not(.hljs) {
      margin-left: 1px;
      margin-right: 1px;
      padding: 0 4px;
      display: inline-block;
      border-radius: 2px;
      font-family: "Operator Mono", "Fira Code", Menlo, Hack, "Roboto Mono", "Liberation Mono", Monaco, monospace;

      pre {
        margin: 8px 0;
      }
    }
  }

  .phone-viewport {
    width: 360px;
    height: 540px;
    margin-right: 16px;
    display: inline-block;
    position: relative;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid rgba(#000, .12);
  }

  .api-table tr > td:first-child {
    white-space: nowrap;
  }

  .pull-left-10{
    margin-left:-10px;
  }

  .main-header {
    z-index: 2;
    color: #fff !important;
  }

  .nav-trigger {
    @media (min-width: 1281px) {
      display: none;
    }
  }

  .md-title {
    flex: 1;

    @media (min-width: 1281px) {
      margin-left: 8px;
    }
  }

  .pd_center {
    text-align: center;
    font-family: serif;
    background-color: #F9FBE7;
  }
</style>

<script>
  // import Vue from 'vue';
  import auth from './scripts/modules/auth.js';
  import {router} from './main.js';

  export default {
    props: ['pageTitle'],
    data() {
      return {
        toolbar: true,
        theme: 'default',
        auth: auth,
        tempTitle: null
      };
    },
    computed: {
      logo() {
        /* let theme = Vue.material.currentTheme;

         if (theme) {
          return require(`assets/logo-vue-material-${theme}.png`);
        } */

        return require('assets/logo-vue-material-default.png');
      }
    },
    watch: {
      tempTitle() {
        this.pageTitle = this.tempTitle;
      }
    },
    methods: {
      redirect(url, title) {
        this.tempTitle = title;
        router.push({
          name: url
        });
      },
      toggleSidenav() {
        this.$refs['main-sidebar'].toggle();
      },
      closeSidenav() {
        this.$refs['main-sidebar'].close();
      },
      signout() {
        auth.signout();
      }
    },
    mounted() {
      if (auth.user.profile === null ) {
        router.push({
          name: 'signin'
        });
      }
      this.tempTitle = 'Map';
    }
  };
</script>



// WEBPACK FOOTER //
// App.vue?026870c8